module.exports = __webpack_public_path__ + "img/1-06.bb037ab8.png";